import React, { useEffect, useState } from "react";
import { employeeService } from "api";
import moment from "moment";
import { Button, Col, Row, Space } from "antd";
import { formatToCurrencyType } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import RenderTemplate from "components/common/DocxTemplate/RenderTemplate";
import dayjs from "dayjs";

interface FormTempaltesProps {
  hdId: string | number;
  closeModal?: () => void;
}
const DEFAULT_WORK_OFFICE =
  "Biệt thự Mimosa 10-11-12, khu Thảo Nguyên - Khu đô thị Ecopark – Huyện Văn Giang – Tỉnh Hưng Yên";
export default function FormTemplates({
  hdId,
  closeModal,
}: FormTempaltesProps) {
  const [chamDutHDLD, setChamDutHDLD] = useState({});
  const [bangDGTV, setBangDGTV] = useState({});
  const [HDLDDCL, setHDLDDCL] = useState({});
  const [HDTV, setHDTV] = useState({});
  const [HDLDL1, setHDLDL1] = useState({});
  const [HDThuViec, setHDThuViec] = useState({});
  const [HDKCB, setHDKCB] = useState({});
  function removeDiacritics(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');
  }
  useEffect(() => {
    if (hdId) {
      getDataChamDutHDLD();
      getDataBangDGTV();
      getDataHDLDDCL();
      getDataHDTV();
      getDataHDLDL1();
      getDataHDKCB(),
      getDataHDThuViec();
    }
  }, [hdId]);

  const getDataChamDutHDLD = async () => {
    const res = await employeeService.getTemplateChamDutHDLD(
      hdId as string | number
    );

    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { cccd_cmnd, ho_ten, ngay_cap_cccd, noi_cap_cccd } = nhan_vien;
    setChamDutHDLD({
      day: separateDate(form_in.ngay_lap_van_ban).day || " ",
      month: separateDate(form_in.ngay_lap_van_ban).month || " ",
      year: separateDate(form_in.ngay_lap_van_ban).year || " ",
      chuc_vu: displayOptData(hop_dong.chuc_vu),
      cccd_cmnd: displayOptData(cccd_cmnd),
      ho_ten: displayOptData(ho_ten),
      ngay_cap_cccd: displayOptData(ngay_cap_cccd),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
    });
  };

  const getDataBangDGTV = async () => {
    const res = await employeeService.getTemplateBangDGTV(
      hdId as string | number
    );

    const { hop_dong = {}, nhan_vien = {} } = res.data.data;
    setBangDGTV({
      chuc_vu: displayOptData(hop_dong.chuc_vu),
      ho_ten: displayOptData(nhan_vien.ho_ten),
      bo_phan: displayOptData(hop_dong.bo_phan),
    });
  };

  const getDataHDLDDCL = async () => {
    const res = await employeeService.getTemplateHDLDDCL(
      hdId as string | number
    );

    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { ngay_lap_van_ban } = form_in;
    const {
      bo_phan,
      chuc_vu,
      ho_tro_an_trua,
      ho_tro_cho_o,
      ho_tro_dien_thoai,
      ho_tro_trach_nhiem,
      ho_tro_trang_phuc,
      ho_tro_xang,
      luong_thang,
      luong_thang_chu,
      luong_thang_chu_TA,
      ngay_nhan_viec,
      so_hd,
      so_phu_luc_hd,
    } = hop_dong;
    const {
      cccd_cmnd,
      dia_chi_thuong_tru,
      ho_ten,
      ngay_cap_cccd,
      ngay_sinh,
      nghe_nghiep,
      nghe_nghiep_TA,
      noi_cap_cccd,
      quoc_tich,
    } = nhan_vien;
    setHDLDDCL({
      ngay: separateDate(ngay_lap_van_ban).day || " ",
      thang: separateDate(ngay_lap_van_ban).month || " ",
      nam: separateDate(ngay_lap_van_ban).year || " ",
      bo_phan: displayOptData(bo_phan),
      chuc_vu: displayOptData(chuc_vu),
      ho_tro_an_trua: displayOptData(formatToCurrencyType(ho_tro_an_trua)),
      ho_tro_cho_o: displayOptData(formatToCurrencyType(ho_tro_cho_o)),
      ho_tro_dien_thoai: displayOptData(
        formatToCurrencyType(ho_tro_dien_thoai)
      ),
      ho_tro_trach_nhiem: displayOptData(
        formatToCurrencyType(ho_tro_trach_nhiem)
      ),
      ho_tro_trang_phuc: displayOptData(
        formatToCurrencyType(ho_tro_trang_phuc)
      ),
      ho_tro_xang: displayOptData(formatToCurrencyType(ho_tro_xang)),
      luong_thang: displayOptData(formatToCurrencyType(luong_thang)),
      luong_thang_chu: displayOptData(luong_thang_chu),
      luong_thang_chu_TA: displayOptData(luong_thang_chu_TA),
      ngay_nhan_viec: displayOptData(
        moment(ngay_nhan_viec).format(FORMAT_TIME.dayFull)
      ),
      so_hd: displayOptData(so_hd),
      so_phu_luc_hd: displayOptData(so_phu_luc_hd),
      cccd_cmnd: displayOptData(cccd_cmnd),
      dia_chi_thuong_tru: displayOptData(dia_chi_thuong_tru),
      ho_ten: displayOptData(ho_ten),
      ho_ten_TA: displayOptData(convertVietnameseToEnglishName(ho_ten)),
      ngay_cap_cccd: displayOptData(
        moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull)
      ),
      ngay_sinh: displayOptData(moment(ngay_sinh).format(FORMAT_TIME.dayFull)),
      nghe_nghiep: displayOptData(nghe_nghiep),
      nghe_nghiep_TA: displayOptData(nghe_nghiep_TA),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
      quoc_tich: displayOptData(quoc_tich),
      ngay_lap_van_ban: displayOptData(
        moment(ngay_lap_van_ban).format(FORMAT_TIME.dayFull)
      ),
    });
  };

  const getDataHDTV = async () => {
    const res = await employeeService.getTemplateHDTV(hdId as string | number);

    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { ngay_lap_van_ban } = form_in;
    const {
      ngay_bat_dau_hd,
      ngay_lap_hd,
      phi_dich_vu,
      so_hd,
      thoi_gian_bao_truoc_nghi,
      trach_nhiem_thue,
    } = hop_dong;
    const {
      cccd_cmnd,
      ngay_cap_cccd,
      ngay_sinh,
      noi_cap_cccd,
      dia_chi_thuong_tru,
      dien_thoai,
      ho_ten,

    } = nhan_vien;

    setHDTV({
      ngay_lap_van_ban: displayOptData(
        moment(ngay_lap_van_ban).format(FORMAT_TIME.dayFull)
      ),
      ngay_bat_dau_hd: displayOptData(
        moment(ngay_bat_dau_hd).format(FORMAT_TIME.dayFull)
      ),
      ngay_lap_hd: displayOptData(
        moment(ngay_lap_hd).format(FORMAT_TIME.dayFull)
      ),
      phi_dich_vu: displayOptData(formatToCurrencyType(phi_dich_vu)),
      so_hd: displayOptData(so_hd),
      ngay_cap_cccd: displayOptData(
        moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull)
      ),
      ngay_sinh: displayOptData(moment(ngay_sinh).format(FORMAT_TIME.dayFull)),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
      thoi_gian_bao_truoc_nghi: displayOptData(thoi_gian_bao_truoc_nghi),
      trach_nhiem_thue: displayOptData(trach_nhiem_thue),
      cccd_cmnd: displayOptData(cccd_cmnd),
      dia_chi_thuong_tru: displayOptData(dia_chi_thuong_tru),
      dien_thoai: displayOptData(dien_thoai),
      ho_ten: displayOptData(ho_ten),
    });
  };

  const getDataHDLDL1 = async () => {
    const res = await employeeService.getTemplateHDLDL1(
      hdId as string | number
    );

    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { ngay_lap_van_ban } = form_in;
    const {
      chuc_vu,
      chuc_vu_ta,
      so_hd,
      luong_thang,
      luong_thang_chu,
      luong_thang_chu_TA,
      ho_tro_xang,
      ho_tro_dien_thoai,
      ho_tro_trang_phuc,
      ho_tro_an_trua,
      ho_tro_cho_o,
      ho_tro_trach_nhiem,
      ngay_bat_dau_hd,
      ngay_het_hd,
      gio_lam_moi_tuan,
      dia_chi_lam_viec,
      dia_chi_lam_viec_ta,
    } = hop_dong;
    const {
      cccd_cmnd,
      ngay_cap_cccd,
      ngay_sinh,
      noi_cap_cccd,
      noi_cap_cccd_ta,
      dia_chi_thuong_tru,
      dia_chi_thuong_tru_ta,
      dien_thoai,
      ho_ten,
      nghe_nghiep,
      nghe_nghiep_TA,
      quoc_tich,
      quoc_tich_ta,
    } = nhan_vien;

    setHDLDL1({
      chuc_vu: displayOptData(chuc_vu),
      ngay_lap_van_ban: displayOptData(
        moment(ngay_lap_van_ban).format(FORMAT_TIME.dayFull)
      ),
      ngay_bat_dau_hd: displayOptData(
        moment(ngay_bat_dau_hd).format(FORMAT_TIME.dayFull)
      ),
      luong_thang: displayOptData(formatToCurrencyType(luong_thang)),
      luong_thang_chu: displayOptData(luong_thang_chu),
      luong_thang_chu_TA: displayOptData(luong_thang_chu_TA),
      ho_tro_xang: displayOptData(formatToCurrencyType(ho_tro_xang)),
      ho_tro_dien_thoai: displayOptData(
        formatToCurrencyType(ho_tro_dien_thoai)
      ),
      ho_tro_trang_phuc: displayOptData(
        formatToCurrencyType(ho_tro_trang_phuc)
      ),
      ho_tro_an_trua: displayOptData(formatToCurrencyType(ho_tro_an_trua)),
      ho_tro_cho_o: displayOptData(formatToCurrencyType(ho_tro_cho_o)),
      ho_tro_trach_nhiem: displayOptData(
        formatToCurrencyType(ho_tro_trach_nhiem)
      ),
      so_hd: displayOptData(so_hd),
      gio_lam_moi_tuan: displayOptData(gio_lam_moi_tuan),
      ngay_cap_cccd: displayOptData(
        moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull)
      ),
      ngay_sinh: displayOptData(moment(ngay_sinh).format(FORMAT_TIME.dayFull)),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
      noi_cap_cccd_TA: displayOptData(noi_cap_cccd_ta),
      cccd_cmnd: displayOptData(cccd_cmnd),
      dia_chi_thuong_tru: displayOptData(dia_chi_thuong_tru),
      dia_chi_thuong_tru_TA: displayOptData(dia_chi_thuong_tru_ta) || "",
      dien_thoai: displayOptData(dien_thoai),
      ho_ten: displayOptData(ho_ten),
      ho_ten_TA:displayOptData(removeDiacritics(ho_ten)),
      nghe_nghiep: displayOptData(nghe_nghiep),
      nghe_nghiep_TA: displayOptData(nghe_nghiep_TA) || "",
      quoc_tich: displayOptData(quoc_tich),
      quoc_tich_TA: displayOptData(quoc_tich_ta) || "",
      chuc_vu_TA: displayOptData(chuc_vu_ta) || "",
      dia_chi_lam_viec: dia_chi_lam_viec || DEFAULT_WORK_OFFICE,
      dia_chi_lam_viec_TA: dia_chi_lam_viec_ta || DEFAULT_WORK_OFFICE || "",
      ngay_het_hd: displayOptData(dayjs(ngay_het_hd).format(FORMAT_TIME.dayFull)) || "",
    });
  };
  const getDataHDKCB = async () => {
    const res = await employeeService.getTemplateHDKCB(
      hdId as string | number
    );
    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { ngay_lap_van_ban } = form_in;
    const {
      chuc_vu,
      chuc_vu_ta,
      dia_chi_lam_viec_ta,
      luong_thang,
      luong_gross,
      ho_tro_khac,
      luong_thang_chu,
      luong_thang_chu_TA,
      ngay_bat_dau_hd,
      ngay_het_hd,
      dia_chi_lam_viec,
      thoi_gian_thu_viec
    } = hop_dong;
    const {
      cccd_cmnd,
      ngay_cap_cccd,
      ngay_sinh,
      noi_sinh,
      noi_cap_cccd,
      dia_chi_thuong_tru,
      dien_thoai,
      ho_ten,
      gioi_tinh,
      ma_nhan_vien,
      noi_cap_cccd_ta,
      nghe_nghiep_TA,
      dia_chi_thuong_tru_ta,
      quoc_tich_ta,
      quoc_tich,
      nghe_nghiep,
    } = nhan_vien;

    setHDKCB({
      ngay_lap_van_ban: displayOptData(
        moment(ngay_lap_van_ban).format(FORMAT_TIME.dayFull)
      ),
      ngay_bat_dau_hd: displayOptData(
        moment(ngay_bat_dau_hd).format(FORMAT_TIME.dayFull)
      ),
      luong_thang: displayOptData(formatToCurrencyType(luong_thang)),
      luong_gross: displayOptData(formatToCurrencyType(luong_gross)),
      ho_tro_khac: displayOptData(formatToCurrencyType(ho_tro_khac)),
      chuc_vu: displayOptData(chuc_vu),
      ngay_cap_cccd: displayOptData(
        moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull)
      ),
      ngay_sinh: displayOptData(moment(ngay_sinh).format(FORMAT_TIME.dayFull)),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
      quoc_tich: displayOptData(quoc_tich),
      gioi_tinh: gioi_tinh === 0 ? "Nam" : "Nữ",
      gioi_tinh_ta: gioi_tinh === 0 ? "Male" : "Female",  // New field added
      cccd_cmnd: displayOptData(cccd_cmnd),
      dia_chi_thuong_tru: displayOptData(dia_chi_thuong_tru),
      dien_thoai: displayOptData(dien_thoai),
      ho_ten: displayOptData(ho_ten),
      dia_chi_lam_viec: displayOptData(dia_chi_lam_viec),
      luong_thang_chu_TA: displayOptData(luong_thang_chu_TA),
      luong_thang_chu: displayOptData(luong_thang_chu),
      ngay_het_hd: displayOptData(moment(ngay_het_hd).format(FORMAT_TIME.dayFull)),
      thoi_gian_thu_viec: displayOptData(thoi_gian_thu_viec),
      ma_nhan_vien: displayOptData(ma_nhan_vien),
      noi_cap_cccd_ta: displayOptData(noi_cap_cccd_ta),
      dia_chi_thuong_tru_ta: displayOptData(dia_chi_thuong_tru_ta),
      ho_ten_ta: displayOptData(removeDiacritics(ho_ten)),
      chuc_vu_ta: displayOptData(chuc_vu_ta),
      dia_chi_lam_viec_ta: displayOptData(dia_chi_lam_viec_ta),
      quoc_tich_ta: displayOptData(quoc_tich_ta),
      nghe_nghiep_TA: displayOptData(nghe_nghiep_TA),
      nghe_nghiep: displayOptData(nghe_nghiep),
      noi_sinh: displayOptData(noi_sinh),
      noi_sinh_ta: displayOptData(removeDiacritics(noi_sinh)),
    });
  };
  const getDataHDThuViec = async () => {
    const res = await employeeService.getTemplateHDThuViec(
      hdId as string | number
    );
    const { form_in = {}, hop_dong = {}, nhan_vien = {} } = res.data.data;
    const { ngay_lap_van_ban } = form_in;
    const {
      chuc_vu,
      chuc_vu_ta,
      dia_chi_lam_viec_ta,
      luong_thang,
      luong_gross,
      ho_tro_khac,
      luong_thang_chu,
      luong_thang_chu_TA,
      ngay_bat_dau_hd,
      ngay_het_hd,
      dia_chi_lam_viec,
      thoi_gian_thu_viec
    } = hop_dong;
    const {
      cccd_cmnd,
      ngay_cap_cccd,
      ngay_sinh,
      noi_cap_cccd,
      dia_chi_thuong_tru,
      dien_thoai,
      ho_ten,
      gioi_tinh,
      ma_nhan_vien,
      noi_cap_cccd_ta,
      nghe_nghiep_TA,
      dia_chi_thuong_tru_ta,
      quoc_tich_ta,
      quoc_tich,
      nghe_nghiep,
    } = nhan_vien;

    setHDThuViec({
      ngay_lap_van_ban: displayOptData(
        moment(ngay_lap_van_ban).format(FORMAT_TIME.dayFull)
      ),
      ngay_bat_dau_hd: displayOptData(
        moment(ngay_bat_dau_hd).format(FORMAT_TIME.dayFull)
      ),
      luong_thang: displayOptData(formatToCurrencyType(luong_thang)),
      luong_gross: displayOptData(formatToCurrencyType(luong_gross)),
      ho_tro_khac: displayOptData(formatToCurrencyType(ho_tro_khac)),
      chuc_vu: displayOptData(chuc_vu),
      ngay_cap_cccd: displayOptData(
        moment(ngay_cap_cccd).format(FORMAT_TIME.dayFull)
      ),
      ngay_sinh: displayOptData(moment(ngay_sinh).format(FORMAT_TIME.dayFull)),
      noi_cap_cccd: displayOptData(noi_cap_cccd),
      quoc_tich: displayOptData(quoc_tich),
      gioi_tinh: gioi_tinh === 0 ? "Nam" : "Nữ",
      gioi_tinh_ta: gioi_tinh === 0 ? "Male" : "Female",  // New field added
      cccd_cmnd: displayOptData(cccd_cmnd),
      dia_chi_thuong_tru: displayOptData(dia_chi_thuong_tru),
      dien_thoai: displayOptData(dien_thoai),
      ho_ten: displayOptData(ho_ten),
      dia_chi_lam_viec: displayOptData(dia_chi_lam_viec),
      luong_thang_chu_TA: displayOptData(luong_thang_chu_TA),
      luong_thang_chu: displayOptData(luong_thang_chu),
      ngay_het_hd: displayOptData(moment(ngay_het_hd).format(FORMAT_TIME.dayFull)),
      thoi_gian_thu_viec: displayOptData(thoi_gian_thu_viec),
      ma_nhan_vien: displayOptData(ma_nhan_vien),
      noi_cap_cccd_ta: displayOptData(noi_cap_cccd_ta),
      dia_chi_thuong_tru_ta: displayOptData(dia_chi_thuong_tru_ta),
      ho_ten_ta: displayOptData(removeDiacritics(ho_ten)),
      chuc_vu_ta: displayOptData(chuc_vu_ta),
      dia_chi_lam_viec_ta: displayOptData(dia_chi_lam_viec_ta),
      quoc_tich_ta: displayOptData(quoc_tich_ta),
      nghe_nghiep_TA: displayOptData(nghe_nghiep_TA),
      nghe_nghiep: displayOptData(nghe_nghiep),
    });
  };

  const displayOptData = (data) => {
    return data || "...............";
  };

  function convertVietnameseToEnglishName(vietnameseName) {
    const words = vietnameseName.split(" ");

    const englishWords = words.map((word) => {
      // Loại bỏ dấu tiếng Việt và chuyển thành chữ cái thường
      return word
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    });

    // Chuyển đổi chữ cái đầu của mỗi từ thành chữ cái hoa
    const englishName = englishWords.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    return englishName.join(" ");
  }

  const separateDate = (inputDate) => {
    const dateObject = moment(inputDate, "YYYY-MM-DD", true);

    if (dateObject.isValid()) {
      const year = dateObject.format("YYYY");
      const month = dateObject.format("MM");
      const day = dateObject.format("DD");

      return { year, month, day };
    } else {
      console.error("Invalid date format");
      return {};
    }
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <RenderTemplate
          data={chamDutHDLD}
          templatePath="/files/Finish-HDLD.docx"
          outputName="Mẫu hơp đồng Chấm dứt HDLD.docx"
          label="Mẫu Chấm dứt HDLD"
        />
        <RenderTemplate
          data={bangDGTV}
          templatePath="/files/BangDGTV.docx"
          outputName="Mẫu hơp đồng đánh giá thử việc.docx"
          label="Mẫu Đánh giá thử việc"
        />
        <RenderTemplate
          data={HDLDDCL}
          templatePath="/files/HDLD-DCL.docx"
          outputName="Mẫu hơp đồng lao động điều chỉnh lương.docx"
          label="Mẫu HĐLĐ điều chỉnh lương"
        />
        <RenderTemplate
          data={HDTV}
          templatePath="/files/HDTV.docx"
          outputName="Mẫu hơp đồng tư vấn.docx"
          label="Mẫu hợp đồng tư vấn"
        />
        <RenderTemplate
          data={HDLDL1}
          templatePath="/files/HDLD-L1.docx"
          outputName="Mẫu hơp đồng lao động lần 1.docx"
          label="Mẫu hợp đồng lao động lần 1"
        />
        <RenderTemplate
          data={HDLDL1}
          templatePath="/files/HDLD-L3.docx"
          outputName="Mẫu hơp đồng lao động lần 3.docx"
          label="Mẫu hợp đồng lao động lần 3"
        />
        <RenderTemplate
          data={HDLDL1}
          templatePath="/files/HDLD-HuuTri.docx"
          outputName="Mẫu hơp đồng lao động hưu trí.docx"
          label="Mẫu hợp đồng lao động hưu trí"
        />
        <RenderTemplate
          data={HDThuViec}
          templatePath="/files/HDThuViec.docx"
          outputName="Mẫu hơp đồng thử việc.docx"
          label="Mẫu hợp đồng thử việc"
        />        
        <RenderTemplate
        data={HDKCB}
        templatePath="/files/HDKCB.docx"
        outputName="Mẫu hơp đồng khám chữa bệnh.docx"
        label="Mẫu hợp đồng khám chữa bệnh"
      />
      </Row>

      <Row justify="end" style={{ marginTop: 12 }}>
        <Col>
          <Space>
            <Button
              onClick={closeModal}
              style={{
                backgroundColor: "red",
                borderColor: "red",
                color: "white",
              }}
            >
              Đóng
            </Button>
          </Space>{" "}
        </Col>
      </Row>
    </div>
  );
}
